export const SET_OPERATOR_LOGO = "SET_OPERATOR_LOGO";

export const setOperatorLogo = (logoUrl) => ({
  type: SET_OPERATOR_LOGO,
  payload: logoUrl,
});
